import { z } from 'zod'

import {
  emailField,
  passwordField,
} from '@maestro/commerce-blocks/schemas/fields'
import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const requestPasswordResetFormSchema = z.object({
  email: emailField,
})

export const resetPasswordFormSchema = z.object({
  token: z.string(),
  newPassword: passwordField,
})

export const resetPasswordWithCodeFormSchema = z.object({
  email: emailField,
  code: z.string().nonempty(m('code.required')),
  newPassword: passwordField,
})
